export default {
  OK: "ठीक छ",
  ok: "ठीक छ",
  loginFailed: "लगइन असफल भयो, कृपया फेरि प्रयास गर्नुहोस्",
  requestFailed: "अनुरोध असफल भयो, कृपया तपाईंको इन्टरनेट जडान जाँच गर्नुहोस्।",
  invalidLogin: "अवैध प्रयोगकर्ता नाम वा पासवर्ड",
  thisFunctionExists: "यो प्रकार्य पहिल्यै अवस्थित छ।",
  thisFunctionNotAllowDelete: "यो प्रकार्य मेट्न अनुमति छैन।",
  thisFunctionNotExists: "यो प्रकार्य अवस्थित छैन।",
  targetFunctionIdRequired: "लक्ष्य प्रकार्य आईडी आवश्यक छ।",
  thisPageExists: "यो पृष्ठ पहिल्यै अवस्थित छ।",
  thisPageNotAllowDelete: "यो पृष्ठ मेट्न अनुमति छैन।",
  thisRoleExists: "यो भूमिका पहिल्यै अवस्थित छ।",
  thisRoleNotAllowDelete: "यो भूमिका मेट्न अनुमति छैन।",
  targetRoleIdRequired: "लक्षित भूमिका आईडी आवश्यक छ।",
  invalidParameter: "अवैध परिमिति",
  systemError: "प्रणालीतपाईंको अनुरोध प्रक्रिया गर्न अक्षम छ।",
  spErrorMessage: "एसपी सन्देश त्रुटि (कुन त्रुटिमा निर्भर गर्नुहोस्)।",
  actionbyRequired: "हालको प्रयोगकर्ता आवश्यक छ।",
  sessionTokenRequired: "सत्र टोकन आवश्यक छ",
  functionIdRequired: "प्रकार्य आईडी आवश्यक छ।",
  functionNameRequired: "प्रकार्य नाम आवश्यक छ।",
  newFunctionNameRequired: "प्रकार्य नाम आवश्यक छ।",
  pageIdRequired: "पृष्ठ आईडी आवश्यक छ।",
  newPageIdRequired: "पृष्ठ आईडी आवश्यक छ।",
  newPageNameRequired: "पृष्ठ नाम आवश्यक छ।",
  targetPageIdRequired: "लक्ष्य पृष्ठ आईडी आवश्यक छ।",
  passwordRequired: "पासवर्ड आवश्यक छ",
  userNameRequired: "पूरा नाम आवश्यक छ",
  passwordValidation: "पासवर्ड ६-२० क्यारेक्टर र नम्बर (हरू) र अक्षर (हरू) को संयोजन हुनुपर्दछ।",
  pageNumRequired: "पृष्ठ नम्बर आवश्यक छ।",
  pageSizeRequired: "पृष्ठ साइज आवश्यक छ।",
  roleIdRequired: "रोल आईडी आवश्यक छ",
  oldPasswordRequired: "हालको पासवर्ड आवश्यक छ।",
  userStatusRequired: "प्रयोगकर्ता स्थिति आवश्यक छ।",
  newRoleIdRequired: "भूमिका आईडी आवश्यक छ।",
  newRoleNameRequired: "भूमिका नाम आवश्यक छ।",
  startDateIsGteEndDate: "सुरु मिति अन्त्य मिति भन्दा ठूलो छ।",
  thisRoleNotExists: "यो भूमिका अवस्थित छैन।",
  thisPageNotExists: "यो पृष्ठ अवस्थित छैन।",
  thisUserExists: "यो प्रयोगकर्ता पहिल्यै अवस्थित छ।",
  thisUserNotExists: "यो प्रयोगकर्ता अवस्थित छैन।",
  thisUserBlackListed: "तपाईंको खाता निलम्बित गरिएको छ।",
  thisUserInactive: "तपाईँको खाता अक्षम पारिएको छ।",
  thisUserBlocked: "तपाईंको खाता ब्लक गरिएको छ।",
  thisUserNotActive: "तपाईँको खाता अक्षम पारिएको छ।",
  InvalidPageFunction: "अवैध पृष्ठ प्रकार्य",
  invalidUser: "अवैध प्रयोगकर्ता!",
  invalidToken: "अवैध सत्र!",
  NoUserAccessRight: "अनुमति अस्वीकार गरियो!",
  connection: "जडान त्रुटि",
  profileIdRequired: "प्रोफाइल आईडी आवश्यक छ।",
  packageIdRequired: "प्याकेज आईडी आवश्यक छ।",
  fullNameMinThreeChar: "पूरा नाम कम्तिमा 3 क्यारेक्टरहरू हुनुपर्दछ।",
  accountIdMinThreeChar: "खाता आईडीमा कम्तिमा 3 क्यारेक्टरहरू हुनुपर्दछ।",
  searchCriteriaRequired: "खोजी मापदण्ड आवश्यक छ।",
  affiliateIdRequired: "एजेन्ट आईडी आवश्यक छ।",
  minDepositRequired: "न्यूनतम डिपोजिट आवश्यक छ",
  bonusRateRequired: "बोनस दर आवश्यक छ",
  onlyAllowRejectDeposit: "केवल डिपोजिट टिकट अस्वीकार गर्न अनुमति दिनुहोस्",
  senderBankIdRequired: "प्रेषक बैंक आईडी आवश्यक छ।",
  senderBankAccNoRequired: "प्रेषक बैंक एसीसी नं. आवश्यक छ।",
  minFTDAmtNumOnly: "न्यूनतम एफटीडी एमट केवल संख्यात्मक स्वीकार करता है",
  maxFTDAmtNumOnly: "अधिकतम एफटीडी एमट केवल संख्यात्मक स्वीकार करता है",
  crmBasicCriteriaRequired: "सदस्य आईडी / सम्पर्क फोन / सम्पर्क ईमेल / साइनअप मिति / अन्तिम लगइन मिति आवश्यक छ।",
  verifiedDateRangeAllowThreeMonths: "साइनअप मिति दायराले केवल 3 महिना सम्म चयन गर्न अनुमति दिन्छ।",
  lastLoginDateRangeAllowThreeMonths: "अन्तिम लगइन मिति दायराले केवल 3 महिना सम्म चयन गर्न अनुमति दिन्छ।",
  depositDateRangeAllowThreeMonths: "डिपोजिट मिति दायरा ले मात्र 3 महिना सम्म चयन गर्न अनुमति दिन्छ।",
  ftdDateRangeAllowThreeMonths: "एफटीडी मिति दायराले केवल 3 महिना सम्म चयन गर्न अनुमति दिन्छ।",
  ltdDateRangeAllowThreeMonths: "लिमिटेड मिति दायरा केवल 3 महिना सम्म चयन गर्न अनुमति दिन्छ।",
  lastLoginDateEarlierThanVerifiedDate: "साइनअप मिति भन्दा पहिले अन्तिम लगइन मिति",
  depositDateEarlierThanVerifiedDate: "साइनअप मिति भन्दा पहिले डिपोजिट मिति",
  ftdDateEarlierThanVerifiedDate: "साइनअप मिति भन्दा पहिले एफटीडी मिति।",
  ltdDateEarlierThanVerifiedDate: "साइनअप मिति भन्दा पहिले लिमिटेड मिति",
  ftdFromRequired: "मितिदेखि एफटीडी आवश्यक छ।",
  ftdToRequired: "आजसम्म एफटीडी आवश्यक छ।",
  ltdFromRequired: "मितिदेखि लिमिटेड आवश्यक छ।",
  ltdToRequired: "लिमिटेड आज सम्म आवश्यक छ।",
  failedToLaunchPaymentGateway: "पेमेन्ट गेटवे सुरु आत गर्न असफल भयो",
  enTitleRequired: "ईएन शीर्षक आवश्यक छ।",
  enBodyRequired: "ईएन शरीर आवश्यक छ।",
  enImageUrlRequired: "ईएन छवि यूआरएल आवश्यक छ।",
  enImageUrlDesktopRequired: "ईएन डेस्कटप छवि यूआरएल आवश्यक छ।",
  enAltRequired: "ईएन अल्ट आवश्यक छ।",
  enHrefRequired: "ईएन एचआरईएफ आवश्यक छ।",
  resubmitTicketRequired: "पुन: सबमिट टिकट आवश्यक छ",
  withtholdBonusAndAmountGreaterThanZero: "विथहोल्ड बोनस र विथहोल्ड रकम एकै समयमा शून्य भन्दा बढी हुन सक्दैन।",
  maxWithdrawMultipleAndAmountGreaterThanZero: "म्याक्सले मल्टिपल झिक्न र अधिकतम निकासी रकम एकै समयमा शून्यभन्दा बढी हुन सक्दैन।",
  serverBusy: "सर्भर अहिले व्यस्त छ । कृपया फेरि प्रयास गर्नुहोस्।",
  isRequired: "कृपया {नाम} प्रविष्ट गर्नुहोस्।",
  isMinValue: "{फनेम} मा न्यूनतम {एफभ्यालु} हुनुपर्दछ।",
  isMaxValue: "{फनाम} {एफभ्यालु} भन्दा कम वा बराबर हुनुपर्दछ।",
  isMinLength: "{नाम} मा कम्तिमा {एफभ्यालु} क्यारेक्टरहरू हुनुपर्दछ।",
  isMaxLength: "{नाम} {एफभ्यालु} क्यारेक्टरभन्दा कम वा बराबर हुनुपर्दछ।",
  isAlpha: "{नाम} केवल वर्णमाला स्वीकार करें",
  isAlphaNum: "{नाम} केवल अल्फान्यूमेरिक्स को स्वीकार करें",
  isNumeric: "{नाम} केवल संख्यात्मक स्वीकार करें",
  isEmail: "{नाम} केवल वैध इमेल ठेगानाहरू स्वीकार गर्नुहोस्।",
  isIpAddress: "{नाम} केवल वैध आईपीवी 4 ठेगानाहरू स्वीकार गर्नुहोस्।",
  isSameAs: "{नाम} {फनाम 2} के समान होना चाहिए।",
  isUrl: "{नाम} केवल यूआरएल स्वीकार करें",
  containAlphaNum: "{नाम} मा कम्तिमा एक वर्णमाला र एक संख्या हुनुपर्दछ।",
  alphaNumWithSpace: "{नाम} केवल अल्फान्यूमेरिक्स को स्वीकार करें",
  isDecimal: "{नाम} केवल संख्यात्मक स्वीकार करें",
  isInteger: "{नाम} केवल पूर्णांक स्वीकार करें",
  selectOption: "कृपया {नाम}चयन गर्नुहोस्",
  notSameAs: "{नाम} र {नाम 2} एउटै हुन सक्दैन।",
  dateRangeAllowOneMonth: "मिति दायराले मात्र 1 महिना सम्म चयन गर्न अनुमति दिन्छ।",
  dateRangeAllowOneYear: "मिति दायराले मात्र 1 वर्ष सम्म चयन गर्न अनुमति दिन्छ।",
  greaterThanZero: "{नाम} शून्य भन्दा ठूलो हुनुपर्दछ।",
  atLeastOneAuthority: "कम्तिमा एक प्राधिकरण चयन गर्नु पर्दछ।",
  BLOCK: "तपाईंको खाता ब्लक गरिएको छ।",
  SUSPEND: "तपाईंको खाता निलम्बित गरिएको छ।",
  CLOSE: "तपाईंको खाता बन्द भएको छ।",
  RESETL: "तपाईंको खाता रिसेट गरिएको छ।",
  atLeastOneProvider: "कम्तिमा एक प्रदायक चयन गर्नु पर्दछ।",
  failedToGetResultUrl: "परिणाम यूआरएल प्राप्त गर्न असफल भयो",
  fileSizeValidation: "धेरै ठूलो, अधिकतम साइज अनुमति 1 एमबी छ",
  atLeastOnePaymentOption: "कम्तिमा एक भुक्तानी विकल्प चयन गर्नु पर्दछ।",
  atLeastOnePaymentGateway: "कम्तिमा एउटा भुक्तानी गेटवे चयन गर्नु पर्दछ।",
  dateRangeAllow31Days: "मिति दायरा ले केवल 31 दिन सम्म चयन गर्न अनुमति दिन्छ।",
  dateRangeAllow31Months: "मिति दायराले मात्र 31 महिनासम्म चयन गर्न अनुमति दिन्छ।",
  dateRangeAllow31Years: "मिति दायराले मात्र 31 वर्ष सम्म चयन गर्न अनुमति दिन्छ।",
  invalidCategory: "अवैध श्रेणी",
  noChanges: "कुनै परिवर्तन छैन।",
  permissionDenied: "अनुमति अस्वीकार गरियो।",
  referralCodeRequired: "रेफरल कोड आवश्यक छ।",
  providerDescRequired: "प्रदायक विवरण आवश्यक छ।",
  marqueeContentRequired: "मार्की सामग्री आवश्यक छ।",
  bonusNameRequired: "बोनस नाम आवश्यक छ",
  baseAmountRequired: "आधार रकम आवश्यक छ।",
  reviewIdRequired: "समीक्षा आईडी आवश्यक छ।",
  surveyIdRequired: "सर्वेक्षण आईडी आवश्यक छ।",
  questionRequired: "प्रश्न आवश्यक छ",
  iframeIdRequired: "इफ्रेम आईडी आवश्यक छ।",
  bonusAmountRequired: "बोनस रकम आवश्यक छ",
  inboxIdRequired: "इनबक्स आईडी आवश्यक छ।",
  exchangedAmountRequired: "विनिमय रकम आवश्यक छ।",
  baseRateRequired: "आधार दर आवश्यक छ",
  exchangeRateRequired: "विनिमय दर आवश्यक छ।",
  baseCurrencyRequired: "आधार मुद्रा आवश्यक छ।",
  exchangeCurrencyRequired: "विनिमय मुद्रा आवश्यक छ।",
  depositTypeRequired: "डिपोजिट प्रकार आवश्यक छ।",
  nbRedepositRequired: "एनबी रिडेपोजिट आवश्यक छ।",
  bankOwnerRequired: "बैंक मालिक आवश्यक छ",
  autoSenderRequired: "स्वत: प्रेषक आवश्यक छ",
  isRecommendRequired: "के सिफारिस आवश्यक छ?",
  recipientBankIdRequired: "प्राप्तकर्ता बैंक आईडी आवश्यक छ",
  recipientBankAccNoRequired: "प्राप्तकर्ता बैंक खाता नम्बर आवश्यक छ",
  accountBalanceRequired: "खाता ब्यालेन्स आवश्यक छ।",
  incomingAmountThresholdRequired: "आवक राशि थ्रेसहोल्ड आवश्यक छ।",
  incomingFrequencyThresholdRequired: "आवक आवृत्ति थ्रेसहोल्ड आवश्यक छ।",
  outgoingAmountThresholdRequired: "बहिर्गमन रकम थ्रेसहोल्ड आवश्यक छ।",
  outgoingFrequencyThresholdRequired: "आउटगोइंग फ्रिक्वेन्सी थ्रेसहोल्ड आवश्यक छ।",
  bankAccTypeRequired: "बैंक खाता प्रकार आवश्यक छ।",
  packageRequired: "प्याकेज आवश्यक छ।",
  rtpRequired: "आरटीपी आवश्यक छ।",
  domainIdRequired: "डोमेन आईडी आवश्यक छ।",
  buyOnBehalfRequired: "तर्फबाट खरीद गर्न आवश्यक छ",
  serviceProviderRequired: "सेवा प्रदायक आवश्यक छ",
  serverAccountRequired: "सर्भर खाता आवश्यक छ।",
  nameServerRequired: "नाम सर्भर आवश्यक छ।",
  socialLinkRequired: "सामाजिक लिङ्क आवश्यक छ।",
  newSocialPlatformRequired: "नयाँ सामाजिक प्लेटफर्म आवश्यक छ।",
  attachmentPathRequired: "अनुलग्नक मार्ग आवश्यक छ।",
  depositMethodRequired: "डिपोजिट विधि आवश्यक छ।",
  depositDateRequired: "डिपोजिट मिति आवश्यक छ।",
  refNoRequired: "सन्दर्भ नम्बर आवश्यक छ।",
  withdrawalAmountRequired: "निकासी रकम आवश्यक छ",
  targetBankAccNoRequired: "लक्षित बैंक खाता नम्बर आवश्यक छ",
  targetBankIdRequired: "लक्षित बैंक आईडी आवश्यक छ",
  jsonRatingRequired: "जेएसओएन रेटिंग आवश्यक छ।",
  startTimeRequired: "सुरु समय आवश्यक छ।",
  accountIdRequired: "खाता आईडी आवश्यक छ",
  parentIdRequired: "अभिभावक आईडी आवश्यक छ।",
  amountRequired: "रकम आवश्यक छ",
  clientIpRequired: "क्लाइन्ट आईपी आवश्यक छ।",
  auditByRequired: "लेखापरीक्षण द्वारा आवश्यक छ",
  systemTypeRequired: "प्रणाली प्रकार आवश्यक छ।",
  currencyRequired: "मुद्रा आवश्यक छ।",
  ipAddressRequired: "आईपी ठेगाना आवश्यक छ।",
  affiliateCodeRequired: "एजेन्ट कोड आवश्यक छ।",
  contactPhoneRequired: "सम्पर्क फोन आवश्यक छ",
  requestTypeRequired: "अनुरोध प्रकार आवश्यक छ।",
  securityDisabledRequired: "सुरक्षा अक्षम पार्नु आवश्यक छ।",
  gameCodeRequired: "गेम कोड आवश्यक छ",
  seqRequired: "अनुक्रम आवश्यक छ।",
  minLimitRequired: "न्यूनतम सीमा आवश्यक छ।",
  maxLimitRequired: "अधिकतम सीमा आवश्यक छ।",
  commSportsRequired: "खेलकुदको लागि कमिसन आवश्यक छ।",
  commSlotsRequired: "स्लटको लागि आयोग आवश्यक छ",
  commLivecasinoRequired: "लाइभ क्यासिनोको लागि कमिशन आवश्यक छ।",
  commCockfightRequired: "ककफाइटको लागि आयोग आवश्यक छ।",
  commOthersRequired: "अरूका लागि कमिसन चाहिन्छ।",
  settingValueRequired: "सेटिङ मान आवश्यक छ।",
  vipIdRequired: "वीआईपी आईडी आवश्यक छ।",
  carryOverRequired: "क्यारी ओभर आवश्यक छ।",
  campaignIdRequired: "अभियान आईडी आवश्यक छ।",
  titleRequired: "शीर्षक आवश्यक छ",
  bodyRequired: "शरीर आवश्यक छ।",
  itemOrderRequired: "आइटम अर्डर आवश्यक छ।",
  imageUrlRequired: "छवि यूआरएल आवश्यक छ।",
  bannerIdRequired: "ब्यानर आईडी आवश्यक छ।",
  directionRequired: "निर्देशन आवश्यक छ।",
  defaultOrderRequired: "पूर्वनिर्धारित अर्डर आवश्यक छ।",
  altRequired: "अल्ट टेक्स्ट आवश्यक छ।",
  hrefRequired: "हर्फ आवश्यक छ।",
  targetWindowRequired: "लक्ष्य सञ्झ्याल आवश्यक छ।",
  loginRequiredRequired: "लगइन आवश्यक छ",
  activeFromRequired: "सक्रिय बाट आवश्यक छ",
  activeToRequired: "सक्रिय गर्न आवश्यक छ",
  bannerTypeRequired: "ब्यानर प्रकार आवश्यक छ।",
  pageNameRequired: "पृष्ठ नाम आवश्यक छ।",
  remarkRequired: "टिप्पणी आवश्यक छ।",
  settingKeyRequired: "सेटिङ कुञ्जी आवश्यक छ।",
  memberListRequired: "सदस्य सूची आवश्यक छ।",
  memberIdRequired: "सदस्य आईडी आवश्यक छ।",
  workingMonthRequired: "काम गर्ने महिना आवश्यक छ।",
  workingDateRequired: "काम गर्ने मिति आवश्यक छ।",
  tacRequired: "नियम र शर्तहरू आवश्यक छ।",
  paymentModeRequired: "भुक्तानी मोड आवश्यक छ।",
  newPasswordRequired: "नयाँ पासवर्ड आवश्यक छ।",
  loginIdRequired: "लगइन आईडी आवश्यक छ।",
  securityTagRequired: "सुरक्षा ट्याग आवश्यक छ।",
  securityCodeRequired: "सुरक्षा कोड आवश्यक छ।",
  providerCodeRequired: "प्रदायक कोड आवश्यक छ।",
  startDateRequired: "सुरु मिति आवश्यक छ।",
  endDateRequired: "अन्त्य मिति आवश्यक छ।",
  searchIdRequired: "खोजी आईडी आवश्यक छ।",
  authTokenRequired: "औथ टोकन आवश्यक छ।",
  newStatusRequired: "नयाँ स्थिति आवश्यक छ।",
  actionRequired: "कार्रवाई आवश्यक है",
  promotionIdRequired: "पदोन्नति आईडी आवश्यक छ",
  promotionNameRequired: "पदोन्नति नाम आवश्यक छ",
  rolloverRequired: "रोलओवर आवश्यक है",
  criteriaRequired: "मापदण्ड आवश्यक छ।",
  ticketIdRequired: "टिकट आईडी आवश्यक छ",
  resultIdRequired: "परिणाम आईडी आवश्यक छ।",
  bankIdRequired: "बैंक आईडी आवश्यक छ",
  bankAccNoRequired: "बैंक खाता नम्बर आवश्यक छ",
  bankAccHolderRequired: "बैंक खाताधारक आवश्यक छ",
  newBankIdRequired: "नयाँ बैंक आईडी आवश्यक छ",
  newBankAccNoRequired: "नयाँ बैंक खाता नम्बर आवश्यक छ।",
  newBankAccHolderRequired: "नयाँ बैंक खाताधारक आवश्यक छ।",
  fullNameRequired: "पूरा नाम आवश्यक छ",
  depositAmountRequired: "डिपोजिट रकम आवश्यक छ",
  gatewayAccRequired: "गेटवे खाता आवश्यक छ।",
  labelNameRequired: "लेबल नाम आवश्यक छ।",
  labelIdRequired: "लेबल आईडी आवश्यक छ।",
  bankTypeRequired: "बैंक प्रकार आवश्यक छ",
  amountLimitRequired: "राशि सीमा आवश्यक छ।",
  currencyRateRequired: "मुद्रा दर आवश्यक छ।",
  urlRequired: "यूआरएल आवश्यक छ।",
  cashRequired: "नगद आवश्यक छ",
  csRequired: "ग्राहक समर्थन आवश्यक छ।",
  vipNameRequired: "वीआईपी नाम आवश्यक छ।",
  campaignNameRequired: "अभियानको नाम आवश्यक छ।",
  transferIdRequired: "स्थानान्तरण आईडी आवश्यक छ।",
  betTimeRequired: "शर्त समय आवश्यक छ।",
  turnoverRequired: "टर्नओवर आवश्यक छ।",
  payoutRequired: "पेआउट आवश्यक छ",
  winloseRequired: "जीत / हार आवश्यक छ",
  rawMessageRequired: "कच्चा सन्देश आवश्यक छ।",
  authStatusRequired: "औथ स्थिति आवश्यक छ।",
  dateRequired: "मिति आवश्यक छ",
  betIdRequired: "शर्त आईडी आवश्यक छ।",
  betStatusRequired: "शर्त स्थिति आवश्यक छ।",
  betAmountRequired: "शर्त रकम आवश्यक छ।",
  isParlayRequired: "क्या पारले आवश्यक है",
  isAddonRequired: "के एडन आवश्यक छ?",
  withholdBonusRequired: "विथहोल्ड बोनस आवश्यक छ",
  withholdAmountRequired: "विथहोल्ड रकम आवश्यक छ",
  maxWithdrawAmountRequired: "अधिकतम निकासी रकम आवश्यक छ।",
  betTypeRequired: "शर्त प्रकार आवश्यक छ।",
  maxWithdrawMultipleRequired: "अधिकतम निकासी एकाधिक आवश्यक छ",
  socialPlatformRequired: "सामाजिक प्लेटफर्म आवश्यक छ।",
  vipProviderRebateRequired: "वीआईपी प्रदाता छूट आवश्यक है",
  selfRebateRateRequired: "स्व छूट दर आवश्यक है",
  downlineRebateRateRequired: "डाउनलाइन छूट दर आवश्यक है",
  tierIdRequired: "टियर आईडी आवश्यक छ।",
  rebateRateRequired: "छूट दर आवश्यक है",
  paymentGatewayRequired: "पेमेन्ट गेटवे आवश्यक छ।",
  rescueIdRequired: "उद्धार आईडी आवश्यक छ।",
  rescueNameRequired: "उद्धार नाम आवश्यक छ।",
  rescueCycleRequired: "उद्धार चक्र आवश्यक छ।",
  minLoseRequired: "न्यूनतम हानि आवश्यक छ।",
  rescueRateRequired: "उद्धार दर आवश्यक छ।",
  maxPayoutRequired: "अधिकतम भुक्तानी आवश्यक छ।",
  payoutMethodRequired: "पेआउट विधि आवश्यक छ।",
  targetGroupRequired: "लक्षित समूह आवश्यक छ।",
  maintainDepositRequired: "डिपोजिट कायम राख्नु आवश्यक छ।",
  maintainTurnoverRequired: "टर्नओवर बनाए रखना आवश्यक है",
  depositOrTurnoverRequired: "डिपोजिट वा टर्नओभर आवश्यक छ।",
  maintainDepositOrMaintainTurnoverRequired: "डिपोजिट कायम राख्नुहोस् वा कारोबार कायम राख्न आवश्यक छ।",
  vipListRequired: "वीआईपी सूची आवश्यक छ।",
  gameNameRequired: "खेल को नाम आवश्यक छ",
  claimTypeRequired: "दावी प्रकार आवश्यक छ।",
  operatorIdRequired: "अपरेटर आईडी आवश्यक छ।",
  maxBonusRequired: "अधिकतम बोनस आवश्यक छ",
  endTimeRequired: "अन्त्य समय आवश्यक छ।",
  mondayRequired: "सोमवार को जरूरत है",
  tuesdayRequired: "मंगलवार को जरूरत है",
  wednesdayRequired: "बुधवार को जरूरत है",
  thursdayRequired: "गुरुवार की जरूरत है",
  fridayRequired: "शुक्रवार को जरूरत है",
  saturdayRequired: "शनिवार को जरूरत है",
  sundayRequired: "रविवार की जरूरत है",
  promotionTypeRequired: "पदोन्नति प्रकार आवश्यक छ।",
  claimLimitRequired: "दावी सीमा आवश्यक छ।",
  bonusRate1Required: "बोनस दर 1 आवश्यक छ।",
  bonusRate1To2Required: "बोनस दर 1 देखि 2 आवश्यक छ",
  bonusRate1To3Required: "बोनस दर 1 देखि 3 आवश्यक छ",
  bonusRate1To4Required: "बोनस दर 1 देखि 4 आवश्यक छ।",
  bonusRate1To5Required: "बोनस दर 1 देखि 5 आवश्यक छ।",
  bonusRate1To6Required: "बोनस दर 1 देखि 6 आवश्यक छ",
  bonusRate1To7Required: "बोनस दर 1 देखि 7 आवश्यक छ",
  externalIdRequired: "बाह्य आईडी आवश्यक छ।",
  opsiteRequired: "ओप्साइट आवश्यक छ।",
  opsiteContentRequired: "ओप्साइट सामग्री आवश्यक छ।",
  opsiteLanguageRequired: "ओप्साइट भाषा आवश्यक छ।",
  opsitePaymentRequired: "ओप्साइट भुक्तान आवश्यक छ।",
  opsiteProviderRequired: "ओप्साइट प्रदायक आवश्यक छ।",
  opsiteProviderGamesRequired: "ओप्साइट प्रदायक खेलहरू आवश्यक छ।",
  accountTypeRequired: "खाता प्रकार आवश्यक छ।",
  domainNameRequired: "डोमेन नाम आवश्यक छ।",
  settledTimeRequired: "स्थिर समय आवश्यक छ।",
  validTurnoverRequired: "वैध कारोबार आवश्यक छ।",
  resultTimeRequired: "परिणाम समय आवश्यक छ।",
  resultStatusRequired: "परिणाम स्थिति आवश्यक छ।",
  secondIdRequired: "दोस्रो आईडी आवश्यक छ।",
  domainListRequired: "डोमेन सूची आवश्यक छ।",
  domainTypeRequired: "डोमेन प्रकार आवश्यक छ।",
  moduleRequired: "मोड्युल आवश्यक छ।",
  gameIdRequired: "गेम आईडी आवश्यक छ",
  gameDetailRequired: "खेल विवरण आवश्यक छ।",
  bonusRate1To8Required: "बोनस दर 1 देखि 8 आवश्यक छ",
  bonusRate1To9Required: "बोनस दर 1 देखि 9 आवश्यक छ।",
  bonusRate1To10Required: "बोनस दर 1 देखि 10 आवश्यक छ",
  invalidOrder: "अवैध आदेश",
  bannerNotExists: "ब्यानर अवस्थित छैन।",
  invalidBannerType: "अवैध ब्यानर प्रकार।",
  pageNameExists: "पृष्ठ नाम अवस्थित छ।",
  pageNotExists: "पृष्ठ अवस्थित छैन।",
  tacIsValid: "ओटीपी वैध है।",
  invalidTac: "अवैध ओटीपी",
  tacExpired: "ओटीपी एक्सपायर",
  tacNotValidate: "ओटीपी मान्य नहीं है",
  paymentModeNotExists: "भुक्तानी मोड अवस्थित छैन।",
  paymentOptionProviderNotExists: "भुक्तानी विकल्प प्रदायक अवस्थित छैन।",
  ipAddressExists: "आईपी ठेगाना अवस्थित छ।",
  ticketProcessed: "टिकट संसाधित",
  bankAccountNotExists: "बैंक खाता अवस्थित छैन",
  bankAccountInactive: "बैंक खाता निष्क्रिय",
  bankMemberNotExists: "बैंक सदस्य अस्तित्वमा छैन",
  bankMemberInactive: "बैंक सदस्य निष्क्रिय",
  affiliateExists: "एजेन्ट अवस्थित छ।",
  contactPhoneExists: "सम्पर्क फोन अवस्थित छ।",
  affiliateFull: "एजेंट फुल",
  uplineInactive: "अपलाइन निष्क्रिय",
  applicationProcessed: "आवेदन प्रक्रिया गरिएको छ।",
  tacValidated: "नियम र शर्तहरू मान्य छन्।",
  applicationPending: "आवेदन लंबित",
  favouriteGameExists: "मनपर्ने खेल अवस्थित छ।",
  invalidLimit: "अवैध सीमा",
  settingNotSet: "सेटिङ सेट गरिएको छैन।",
  domainNameNotExists: "डोमेन नाम अवस्थित छैन।",
  domainNameFull: "डोमेन नाम भरिएको छ।",
  domainNameNotAvailable: "डोमेन नाम उपलब्ध छैन।",
  domainNameExists: "डोमेन नाम अवस्थित छ।",
  subAccountNotExists: "उप-खाता अवस्थित छैन।",
  settingNotExists: "सेटिङ अवस्थित छैन।",
  invalidContactEmail: "अवैध सम्पर्क इमेल",
  accountInactive: "खाता निष्क्रिय छ।",
  campaignNotExists: "अभियान अस्तित्वमा छैन।",
  paymentProviderNotExists: "भुक्तानी प्रदायक अवस्थित छैन।",
  profileInactive: "प्रोफाइल निष्क्रिय",
  minWithdrawalNotMet: "न्यूनतम निकासी पूरा भएको छैन।",
  invalidBankId: "अवैध बैंक आईडी",
  bankAccountExists: "बैंक खाता अवस्थित छ।",
  bankAccountFull: "बैंक खाता भरिएको छ।",
  bankAccHolderNotSame: "बैंक खाताधारक समान छैन",
  exceedMaxWithdrawal: "अधिकतम निकासी से अधिक",
  exceedWithdrawalFrequency: "निकासी आवृत्ति से अधिक",
  invalidPackage: "अवैध प्याकेज",
  promotionNotAvailable: "पदोन्नति उपलब्ध छैन।",
  ongoingPromotion: "चल रही पदोन्नति",
  pendingResultInGame: "खेल में लंबित परिणाम",
  labelNameExists: "लेबल नाम अवस्थित छ।",
  labelNotExists: "लेबल अवस्थित छैन।",
  invalidFtdMin: "अवैध प्रथम-समय जमा न्यूनतम",
  invalidFtdMax: "अवैध प्रथम-समय जमा अधिकतम",
  ftdMinGtFtdMax: "पहिलो पटक जम्मा न्यूनतम अधिकतम भन्दा बढी।",
  vipFull: "वीआईपी पूर्ण।",
  invalidRewardType: "अवैध इनाम प्रकार",
  vipExists: "वीआईपी मौजूद है।",
  vipNotExists: "वीआईपी अस्तित्वमा छैन।",
  onlyOneMaxWithdrawSetting: "केवल एक अधिकतम वापस लेने की अनुमति दी गई",
  onlyOneWithholdSetting: "केवल एक रोक सेटिंग अनुमति दी गई",
  campaignExists: "अभियान अवस्थित छ।",
  vipProviderNotExists: "वीआईपी प्रदायक अवस्थित छैन।",
  turnoverTierExists: "टर्नओवर स्तर अवस्थित छ।",
  turnoverTierFull: "टर्नओवर स्तर अधिकतम स्तर से अधिक है",
  turnoverTierNotExists: "टर्नओवर स्तर अवस्थित छैन।",
  invalidSettingValue: "अवैध सेटिङ मान",
  turnoverTierNotSet: "टर्नओवर स्तर सेट गरिएको छैन।",
  rebateProcessed: "छूट संसाधित",
  invalidActionType: "अवैध कार्य प्रकार।",
  invalidRescueCycle: "अवैध बचाव चक्र",
  invalidPayoutMethod: "अवैध पेआउट विधि",
  invalidTargetGroup: "अवैध लक्ष्य समूह",
  rescueExists: "उद्धार अवस्थित छ।",
  rescueNotExists: "उद्धार अस्तित्वमा छैन।",
  walletExists: "वालेट अवस्थित छ।",
  accountExists: "खाता अवस्थित छ।",
  activeFromGtActiveTo: "सक्रिय भन्दा बढी देखि सक्रिय",
  accountNotExists: "अपरेटर आईडी अवस्थित छैन।",
  invalidDeposit: "अवैध जमा",
  invalidTurnover: "अवैध कारोबार",
  providerCodeNotExists: "प्रदायक कोड अवस्थित छैन।",
  gameNameExists: "खेल नाम अवस्थित छ।",
  gameNameNotExists: "खेल नाम अवस्थित छैन।",
  invalidAccountType: "अवैध खाता प्रकार।",
  invalidLoginIdFormat: "अवैध लगइन आईडी ढाँचा",
  invalidReferralCode: "अवैध रेफरल कोड",
  firstDepositNotMet: "पहिलो जम्मा मिलेको छैन",
  newbieNotMet: "नौसिखिया आवश्यकताएं पूरी नहीं हुईं",
  claimPromoOnlyOnce: "केवल एक बार पदोन्नति का दावा करें",
  promotionRequirementNotMet: "पदोन्नति आवश्यकता पूरा भएको छैन।",
  withdrawalAmountLteWithholdAmount: "विथहोल्ड रकम भन्दा कम वा बराबर निकासी रकम।",
  subAccountInactive: "उप-खाता निष्क्रिय",
  gameNotSupported: "खेल समर्थित छैन",
  startTimeGteEndTime: "अन्त्य समय भन्दा ठूलो वा बराबर सुरु समय।",
  invalidPromotionType: "अवैध पदोन्नति प्रकार",
  invalidClaimType: "अवैध दाबी प्रकार।",
  claimLimitExceeded10: "दावा सीमा 10 से अधिक",
  verificationFailed: "प्रमाणीकरण असफल भयो।",
  claimLimitReached: "दावा सीमा पहुंच गई",
  invalidPromotion: "अवैध पदोन्नति",
  socialPlatformExists: "सामाजिक मञ्च अवस्थित छ।",
  duplicateReview: "डुप्लिकेट समीक्षा",
  invalidSurveyId: "अवैध सर्वेक्षण आईडी",
  accountNotBlock: "खाता अवरुद्ध गरिएको छैन।",
  walletNotExists: "वालेट अवस्थित छैन।",
  socialPlatformNotExists: "सामाजिक मञ्च अस्तित्वमा छैन।",
  socialPlatformInactive: "सामाजिक मंच निष्क्रिय",
  accountSocialExists: "सामाजिक खाता अवस्थित छ।",
  invalidStatus: "अवैध स्थिति",
  samePassword: "उही पासवर्ड",
  invalidPassword: "अवैध प्रयोगकर्ता नाम वा पासवर्ड",
  secondaryAccountExists: "माध्यमिक खाता अवस्थित छ।",
  invalidSecurityCode: "अवैध सुरक्षा कोड",
  accountSocialNotExists: "खाता सामाजिक अवस्थित छैन।",
  providerInactive: "प्रदाता निष्क्रिय",
  gameIdExists: "गेम आईडी अवस्थित छ।",
  gameIdNotExists: "गेम आईडी अवस्थित छैन।",
  parentProviderInactive: "अभिभावक प्रदायक निष्क्रिय",
  betLimitNotExists: "शर्त सीमा अवस्थित छैन।",
  min3Characters: "न्यूनतम ३ क्यारेक्टर",
  invalidBankAccType: "अवैध बैंक खाता प्रकार",
  senderBankNotExists: "प्रेषक बैंक अवस्थित छैन।",
  recipientBankNotExists: "प्राप्तकर्ता बैंक अवस्थित छैन।",
  affiliateNotExists: "एजेन्ट अस्तित्वमा छैन।",
  redepositedTicket: "पुन: जमा टिकट",
  invalidDepositType: "अवैध डिपोजिट प्रकार",
  affiliateInactive: "एजेंट निष्क्रिय",
  bonusUnavailable: "बोनस अनुपलब्ध",
  pendingDeposit: "लंबित जमा",
  noOngoingPromotion: "कुनै चलिरहेको पदोन्नति छैन।",
  iframeNotExists: "आईफ्रेम अस्तित्वमा छैन।",
  gameMaintenance: "खेल रखरखाव",
  labelInactive: "लेबल निष्क्रिय।",
  invalidDomainType: "अवैध डोमेन प्रकार।",
  invalidModule: "अवैध मोड्युल",
  labelFull: "लेबल पूर्ण",
  questionExists: "प्रश्न अवस्थित छ।",
  questionFull: "प्रश्न पूर्ण",
  questionNotExists: "प्रश्न अस्तित्वमा छैन।",
  reviewNotExists: "समीक्षा अवस्थित छैन।",
  invalidDomainGroup: "अवैध डोमेन समूह",
  invalidDateRange: "अवैध मिति दायरा",
  ipAddressNotExists: "आईपी ठेगाना अवस्थित छैन।",
  marqueeNotExists: "मार्की को अस्तित्व नहीं है।",
  invalidAmount: "अवैध रकम",
  insufficientBalance: "अपर्याप्त संतुलन",
  minLimitLtParent: "न्यूनतम सीमा माता-पिता से कम",
  maxLimitGtParent: "अधिकतम सीमा माता-पिता से अधिक",
  startDateGtEndDate: "सुरु मिति अन्त्य मिति भन्दा ठूलो छ।",
  currencyNotExists: "मुद्रा अस्तित्वमा छैन।",
  currencyExists: "मुद्रा अवस्थित छ।",
  noAccumulateWin: "कोई संचित जीत नहीं",
  invalidSession: "अवैध सत्र",
  sessionExpired: "सत्र समाप्त हो गया",
  promotionExists: "पदोन्नति अवस्थित छ।",
  invalidCriteria: "अवैध मापदण्ड",
  promotionNotExists: "पदोन्नति अस्तित्वमा छैन।",
  ticketNotExists: "टिकट अस्तित्वमा छैन।",
  duplicateDebitRecord: "डुप्लिकेट डेबिट रिकॉर्ड",
  duplicateCreditRecord: "डुप्लिकेट क्रेडिट रिकॉर्ड",
  debitRecordNotExists: "डेबिट रेकर्ड अवस्थित छैन।",
  minDepositNotMet: "न्यूनतम जमा पूरा नहीं हुआ",
  duplicateBet: "डुप्लिकेट शर्त",
  invalidProviderCode: "अवैध प्रदायक कोड",
  resultExists: "परिणाम अवस्थित छ।",
  unableSPProcess: "प्रणालीतपाईंको अनुरोध प्रक्रिया गर्न अक्षम छ।",
  authRequired: "प्रमाणीकरण कोड आवश्यक छ।",
  domainExists: "डोमेन पहिल्यै अवस्थित छ।",
  multiSelectOption: "कृपया {नाम}चयन गर्नुहोस्",
  invalidDomainFormat: "अवैध डोमेन ढाँचा",
  noHttpHttps: "'https://' वा 'http://' अनुमति छैन।",
  noReservedSubdomain: "आरक्षित उपडोमेन अनुमति छैन। अनुप्रयोग डाउनलोड लिङ्क प्रयोगको लागि।",
  operatorInactive: "अपरेटर निष्क्रिय छ",
  invalidAccountIdFormat: "अवैध खाता आईडी ढाँचा",
  contentIdRequired: "मेनु आईडी आवश्यक छ",
  themeCodeRequired: "थीम कोड आवश्यक छ",
  themeNameRequired: "विषयवस्तु नाम आवश्यक छ",
  themeColorRequired: "विषयवस्तु रङ आवश्यक छ",
  languageRequired: "भाषा आवश्यक छ",
  positionRequired: "स्थिति आवश्यक छ",
  themeContentIdRequired: "विषयवस्तु सामग्री आईडी आवश्यक छ",
  emailRequired: "इमेल आवश्यक छ",
  themeProviderTypeRequired: "विषयवस्तु प्रदायक प्रकार आवश्यक छ",
  phoneRequired: "फोन आवश्यक छ",
  targetTypeRequired: "लक्ष्य प्रकार आवश्यक छ",
  packageTypeRequired: "प्याकेज प्रकार आवश्यक छ",
  renewTermRequired: "नवीकरण अवधि आवश्यक छ",
  packagePriceRequired: "प्याकेज मूल्य आवश्यक छ",
  packageStatusRequired: "प्याकेज स्थिति आवश्यक छ",
  sortKeyRequired: "क्रमबद्ध कुञ्जी आवश्यक छ",
  invalidDomainStatus: "अवैध डोमेन स्थिति",
  invalidCurrency: "अमान्य मुद्रा",
  invalidThemeCode: "अवैध विषयवस्तु सङ्केत",
  invalidLanguage: "अवैध भाषा",
  invalidPosition: "अवैध स्थिति",
  invalidThemeContent: "अवैध विषयवस्तु सामग्री",
  allParamsSameAsCurrent: "त्यहाँ कुनै परिवर्तन छैन",
  invalidThemeColor: "अवैध विषयवस्तु रङ",
  invalidCartStatus: "अवैध कार्ट स्थिति",
  invalidThemeProviderType: "अवैध विषयवस्तु प्रदायक प्रकार",
  themeProviderTypeCannotBeUse: "विषयवस्तु प्रदायक प्रकार प्रयोग गर्न सकिँदैन",
  invalidUserStatus: "अवैध प्रयोगकर्ता स्थिति",
  packageCannotBeRemove: "प्याकेज हटाउन सकिदैन",
  userStatusIsAlrdSuspend: "प्रयोगकर्ता पहिल्यै निलम्बित छ",
  userStatusIsAlrdBlocked: "प्रयोगकर्ता पहिल्यै अवरुद्ध छ",
  userStatusIsAlrdActive: "प्रयोगकर्ता पहिल्यै सक्रिय छ",
  invalidSortType: "अवैध क्रमबद्ध प्रकार",
  startDateBiggerThanEndDate: "सुरु मिति अन्त्य मिति भन्दा ठूलो छ",
  positionCannotBeUse: "स्थिति प्रयोग गर्न सकिँदैन",
  funcAddContentFailed: "सामग्री थप्न असफल भयो",
  funcDeleteContentFailed: "सामग्री मेट्न असफल भयो",
  funcUpdateContentFailed: "सामग्री अद्यावधिक गर्न असफल भयो",
  funcAddThemeFailed: "विषयवस्तु थप्न असफल भयो",
  funcDeleteThemeFailed: "विषयवस्तु मेट्न असफल भयो",
  funcUpdateThemeFailed: "विषयवस्तु अद्यावधिक गर्न असफल भयो",
  funcAddThemeColorFailed: "विषयवस्तु रङ थप्न असफल भयो",
  funcDeleteThemeColorFailed: "विषयवस्तु रङ मेट्न असफल भयो",
  funcUpdateThemeColorFailed: "विषयवस्तु रङ अद्यावधिक गर्न असफल भयो",
  funcAddLanguageFailed: "भाषा थप्न असफल भयो",
  funcDeleteLanguageFailed: "भाषा मेट्न असफल भयो",
  funcUpdateLanguageFailed: "भाषा अद्यावधिक गर्न असफल भयो",
  funcAddThemeContentFailed: "विषयवस्तु सामग्री थप्न असफल भयो",
  funcDeleteThemeContentFailed: "विषयवस्तु सामग्री मेट्न असफल भयो",
  funcUpdateThemeContentFailed: "विषयवस्तु सामग्री अद्यावधिक गर्न असफल भयो",
  funcAddContentPositionFailed: "सामग्री स्थिति थप्न असफल भयो",
  funcUpdateContentPositionFailed: "सामग्री स्थिति अद्यावधिक गर्न असफल भयो",
  funcDeleteContentPositionFailed: "सामग्री स्थिति मेट्न असफल भयो",
  funcAddThemeProviderTypeFailed: "विषयवस्तु प्रदायक प्रकार थप्न असफल भयो",
  funcUpdateThemeProviderTypeFailed: "विषयवस्तु प्रदायक प्रकार अद्यावधिक गर्न असफल भयो",
  funcDeleteThemeProviderTypeFailed: "विषयवस्तु प्रदायक प्रकार मेट्न असफल भयो",
  funcAddPackageFailed: "प्याकेज थप्न असफल भयो",
  funcUpdatePackageFailed: "प्याकेज अद्यावधिक गर्न असफल भयो",
  funcDeletePackageFailed: "प्याकेज मेट्न असफल भयो",
  nicknameRequired: "उपनाम आवश्यक छ",
  accountStatusRequired: "खाता को स्थिति आवश्यक छ",
  contentIdMaxLength50: "मेनु आईडी अधिकतम लम्बाई 50 हो",
  positionMaxLength10: "स्थिति अधिकतम लम्बाई 10 हो",
  contentDescMaxLength200: "सामग्री विवरण अधिकतम लम्बाई 200 हो",
  domainStatusRequired: "डोमेन स्थिति आवश्यक छ",
  funcAddDomainFailed: "डोमेन थप्न असफल भयो",
  funcUpdateDomainFailed: "डोमेन अद्यावधिक गर्न असफल भयो",
  uploadFailed: "अपलोड गर्न असफल भयो!",
  sortKeyMaxLength50: "क्रमबद्ध कुञ्जी अधिकतम लम्बाइ 50 हो",
  invalidSortTypeFormat: "अवैध क्रमबद्ध प्रकार ढाँचा",
  invalidPackageId: "अवैध प्याकेज आईडी",
  invalidAccountStatusFormat: "अवैध खाता स्थिति ढाँचा",
  invalidSiteStatusFormat: "अवैध साइट स्थिति ढाँचा",
  invalidPackageStatus: "अवैध प्याकेज स्थिति",
  invalidEmailFormat: "अवैध इमेल ढाँचा",
  invalidPhoneFormat: "अवैध फोन ढाँचा",
  languageLengthNotInRange: "भाषाको लम्बाइ दायरामा छैन (2-5)",
  languageDescriptionMaxLength50: "भाषा विवरण अधिकतम लम्बाई 50 है",
  remarkMaxLength500: "टिप्पणी अधिकतम लंबाई 500 है",
  themeProviderTypeMaxLength50: "थीम प्रदायक प्रकार अधिकतम लम्बाई 50 है",
  themeNameMaxLength50: "थीम नाम अधिकतम लम्बाई 50 है",
  themeColorMaxLength20: "थीम रङ अधिकतम लम्बाइ २० हो",
  noSpace: "खाली स्थान समावेश गर्नु हुँदैन",
  packageDescEnRequired: "नाम अंग्रेजी आवश्यक छ",
  packageDescEnMaxLength20: "नाम अंग्रेजी अधिकतम लंबाई 20 है",
  allParamsIsNull: "सबै परिमितिहरू शून्य छन्",
  contentCannotBeRemove: "सामग्री हटाउन सकिँदैन",
  contentDetailsRequired: "सामग्री विवरण आवश्यक छ",
  domainCannotBeUse: "डोमेन प्रयोग गर्न सकिँदैन",
  domainGroupMaxLength20: "डोमेन समूह अधिकतम लंबाई 20 है",
  domainGroupRequired: "डोमेन समूह आवश्यक छ",
  domainNameCannotUpdate: "डोमेन नाम अद्यावधिक गर्न सकिँदैन",
  domainNameMaxLength400: "डोमेन नाम अधिकतम लम्बाई 400 है",
  domainsRequired: "डोमेनहरू आवश्यक छन्",
  domainStatusMaxLength20: "डोमेन स्थिति अधिकतम लंबाई 20 है",
  domainTypeMaxLength10: "डोमेन प्रकार अधिकतम लंबाई 10 है",
  funcAddThemeContentGroupFailed: "विषयवस्तु सामग्री समूह थप्न असफल भयो",
  funcDeleteThemeContentGroupFailed: "विषयवस्तु सामग्री समूह मेट्न असफल भयो",
  funcOpsiteUpdateFailed: "ओप्साइट अपडेट असफल भयो",
  funcResetAccountPasswordFailed: "खाता पासवर्ड रिसेट असफल भयो",
  funcSiteLanguageUpsertFailed: "साइट भाषा अपसर्ट असफल",
  funcSiteThemeContentUpsertFailed: "साइट विषयवस्तु सामग्री अपसर्ट असफल भयो",
  funcSiteThemeUpsertFailed: "साइट थीम अपसर्ट असफल",
  funcSiteUpdateFailed: "साइट अद्यावधिक असफल भयो",
  funcUpdateAccountFailed: "अद्यावधिक खाता असफल भयो",
  funcUpdateAccountStatusActiveFailed: "सक्रिय असफल मा खाता स्थिति अद्यावधिक गर्नुहोस्",
  funcUpdateAccountStatusCompanyBlockFailed: "कम्पनी ब्लकमा खाता स्थिति अद्यावधिक गर्न असफल भयो",
  funcUpdateAccountStatusSuspendFailed: "निलम्बित गर्न खाता स्थिति अद्यावधिक गर्न असफल भयो",
  funcUpdateThemeContentGroupFailed: "विषयवस्तु सामग्री समूह अद्यावधिक गर्न असफल भयो",
  invalidBoDomain: "अवैध बीओ डोमेन",
  invalidOperatorIdFormat: "अवैध अपरेटर आईडी ढाँचा",
  invalidOpsite: "अवैध ओप्साइट",
  invalidOpsiteOperator: "अवैध अपसाइट अपरेटर",
  invalidOpsiteVersion: "अवैध ओप्साइट संस्करण",
  invalidParentContentInGroup: "समूहमा अवैध अभिभावक सामग्री",
  invalidSite: "अवैध साइट",
  invalidSiteStatus: "अवैध साइट स्थिति",
  invalidThemeContentGroup: "अवैध विषयवस्तु सामग्री समूह",
  languageCannotBeUse: "भाषा प्रयोग गर्न सकिदैन",
  languagesRequired: "भाषाहरू आवश्यक छन्",
  logo1Required: "लोगो आवश्यक छ",
  notSupportMultiDefault: "बहु-पूर्वनिर्धारित समर्थित छैन",
  operatorIdMaxLength50: "अपरेटर आईडी अधिकतम लम्बाई 50 हो",
  opsiteNotMatch: "ओप्साइट मेल खाँदैन",
  packageTypeMaxLength15: "पैकेज प्रकार अधिकतम लंबाई 15 है",
  parentContentIdCannotSameWithContentId: "अभिभावक सामग्री आईडी सामग्री आईडी जस्तै समान हुन सक्दैन",
  phoneNumberRequired: "फोन नम्बर आवश्यक छ",
  siteIdRequired: "साइट आईडी आवश्यक छ",
  siteNameMaxLength50: "साइट नाम अधिकतम लंबाई 50 है",
  siteNameRequired: "साइट नाम आवश्यक छ",
  technicalError: "प्राविधिक त्रुटि",
  themeCannotBeRemove: "विषयवस्तु हटाउन सकिँदैन",
  themeCodeCannotBeUse: "विषयवस्तु कोड प्रयोग गर्न सकिँदैन",
  themeCodeMaxLength20: "थीम कोड अधिकतम लंबाई 20 है",
  themeColorCannotBeRemove: "विषयवस्तु रङ हटाउन सकिँदैन",
  themeColorCannotBeUse: "विषयवस्तु रङ प्रयोग गर्न सकिँदैन",
  themeContentCannotBeUse: "विषयवस्तु सामग्री प्रयोग गर्न सकिँदैन",
  themeContentGroupCannotBeUse: "विषयवस्तु सामग्री समूह प्रयोग गर्न सकिँदैन",
  themeContentGroupDescriptionMaxLength50: "थीम सामग्री समूह विवरण अधिकतम लम्बाई 50 है",
  themeContentGroupMaxLength20: "थीम सामग्री समूह अधिकतम लम्बाई 20 है",
  themeContentGroupRequired: "विषयवस्तु सामग्री समूह आवश्यक छ",
  themeNameCannotBeUse: "विषयवस्तु नाम प्रयोग गर्न सकिँदैन",
  userHaventVerifyThisBefore: "प्रयोगकर्ताले यसलाई पहिले प्रमाणित गरेको छैन",
  isDefaultTrueRequired: "भाषामा १ पूर्वनिर्धारित हुनुपर्दछ",
  accountIdMaxLength50: "प्रयोगकर्ता आईडी अधिकतम लम्बाई 50 हो",
  headBodyScriptEitherOne: "कृपया हेड स्क्रिप्ट वा बडी स्क्रिप्ट प्रविष्ट गर्नुहोस्",
  alphaOrNum: "वर्णमाला वा संख्या मात्र हुनुपर्छ",
  phoneValid: "कृपया वैध फोन नम्बर प्रविष्ट गर्नुहोस्",
  permittedAmountRequired: "अनुमति प्राप्त रकम आवश्यक छ",
  ignoreRiskRequired: "जोखिम को नजरअंदाज करना आवश्यक है",
  paymentDescRequired: "भुक्तानी विवरण आवश्यक छ",
  gameTypeRequired: "खेल प्रकार आवश्यक छ",
  statusRequired: "स्थिति आवश्यक छ",
  payoutIdRequired: "पेआउट आईडी आवश्यक छ",
  commNotExists: "आयोग अस्तित्वमा छैन",
  parentCommNotExists: "अभिभावक आयोग अवस्थित छैन",
  carryOverNotExists: "क्यारी ओभर अवस्थित छैन",
  hotGameExists: "तातो खेल पहिल्यै अवस्थित छ",
  commSportsExceededParent: "खेलको लागि आयोग अभिभावकभन्दा बढी थियो",
  commSlotsExceededParent: "स्लटको लागि आयोग अभिभावकभन्दा बढी थियो",
  commLivecasinoExceededParent: "लाइभ क्यासिनोको लागि कमिशनले अभिभावकलाई पार गर्यो",
  commCockfightExceededParent: "कॉकफाइट के लिए आयोग माता-पिता से अधिक हो गई",
  commOthersExceededParent: "अरूका लागि कमिसनले आमाबाबुलाई पार गर् यो",
  hotGameNotExists: "तातो खेल अवस्थित छैन",
  noSecurityDeposit: "कुनै सुरक्षा कोष छैन",
  exchangeRateNotExists: "विनिमय दर अवस्थित छैन",
  insufficientSecurityDeposit: "अपर्याप्त सुरक्षा कोष",
  duplicateDomain: "डुप्लिकेट डोमेन",
  contactEmailNotExists: "सम्पर्क इमेल अवस्थित छैन",
  featuredGameNotExists: "फीचर खेल अवस्थित छैन",
  newGameNotExists: "नयाँ खेल अवस्थित छैन",
  popularGameNotExists: "लोकप्रिय खेल अवस्थित छैन",
  featuredGameExists: "सुविधा खेल पहिल्यै अवस्थित छ",
  newGameExists: "नयाँ खेल पहिल्यै अवस्थित छ",
  popularGameExists: "लोकप्रिय खेल पहिले नै अवस्थित छ",
  rebateNotExists: "छूट मौजूद नहीं है",
  riskyMember: "जोखिमपूर्ण सदस्य",
  ipRestricted: "आईपी प्रतिबन्धित",
  notSupportedBank: "समर्थित बैंक छैन",
  requestTooFrequent: "अनुरोध धेरै बारम्बार छ।",
  paymentOptionNotExists: "भुक्तानी विकल्प अवस्थित छैन।",
  earningIdRequired: "कमाई आईडी आवश्यक छ",
  ptOnRequired: "पीटी आवश्यक पर",
  ptRequired: "पीटी आवश्यक",
  userIdRequired: "प्रयोगकर्ता आईडी आवश्यक छ।",
  businessIdRequired: "व्यवसाय आईडी आवश्यक छ।",
  subAccountIdRequired: "उप खाता आईडी आवश्यक छ",
  sourceAccountIdRequired: "स्रोत खाता आईडी आवश्यक छ।",
  targetAccountIdRequired: "लक्षित खाता आईडी आवश्यक छ।",
  ticketTaken: "टिकट लिइयो",
  ticketNotTaken: "टिकट लिइएन",
  invalidPt: "अवैध पीटी",
  topupIdRequired: "टप अप आईडी आवश्यक छ",
  promotionMemberLogNotExists: "पदोन्नति सदस्य लग अवस्थित छैन",
  paymentOptionInactive: "भुक्तानी विकल्प निष्क्रिय",
  invalidCartStatusFormat: "अवैध कार्ट स्थिति ढाँचा",
  requestIncompleted: "अनुरोध अपूर्ण",
  unknownError: "अज्ञात त्रुटि उत्पन्न भयो",
  cartIdRequired: "कार्ट आईडी आवश्यक छ",
  stepNameRequired: "चरण नाम आवश्यक छ",
  invalidCart: "अवैध कार्ट",
  invalidStepName: "अवैध चरण नाम",
  cartHaventSetupComplete: "कार्ट पूरा सेटअप भएको छैन",
  funcCartCreateFailed: "कार्ट सिर्जना गर्न असफल भयो",
  funcCartUpdateFailed: "कार्ट अद्यावधिक गर्न असफल भयो",
  funcSiteCreateFailed: "साइट सिर्जना गर्न असफल भयो",
  funcCartPurchasedUpdateFailed: "खरिद गरिएको कार्ट अद्यावधिक गर्न असफल भयो",
  invalidPasswordFormat: "अवैध पासवर्ड ढाँचा",
  currencyCodeRequired: "मुद्रा आवश्यक छ",
  funcCartLanguageUpsertFailed: "फंक्शन कार्ट लैंग्वेज अपसर्ट फेल",
  invalidUserIdFormat: "अवैध प्रयोगकर्ता आईडी ढाँचा",
  operatorPasswordRequired: "अपरेटर पासवर्ड आवश्यक छ",
  funcCartOperatorInfoUpsertFailed: "फंक्शन कार्ट ऑपरेटर जानकारी अपसर्ट फेल",
  invalidOperatorPasswordFormat: "अवैध अपरेटर पासवर्ड ढाँचा",
  operatorIdCannotBeUse: "अपरेटर आईडी प्रयोग गर्न सकिँदैन",
  siteNameLengthNotInRange: "साइट नाम लम्बाइ दायरामा छैन",
  userIdCannotBeUse: "प्रयोगकर्ता आईडी प्रयोग गर्न सकिँदैन",
  siteIdAlrdExist: "साइट आईडी पहिल्यै अवस्थित छ",
  operatorIdAlrdExist: "अपरेटर आईडी पहिल्यै अवस्थित छ",
  externalIdAlrdExist: "बाह्य आईडी पहिल्यै अवस्थित छ",
  opsiteContentAlrdExist: "साइट सामग्री विषयवस्तु सामग्री पहिल्यै अवस्थित छ",
  opsiteLanguageAlrdExist: "साइट सामग्री भाषा पहिल्यै अवस्थित छ",
  boAccountAlrdExist: "बीओ खाता पहिल्यै अवस्थित छ",
  boAccountProfileAlrdExist: "बीओ खाता प्रोफाइल पहिल्यै अवस्थित छ",
  boAccountLoginAlrdExist: "बीओ खाता लगइन पहिल्यै अवस्थित छ",
  funcCartThemeCodeUpsertFailed: "कार्ट विषयवस्तु अपसर्ट गर्न असफल भयो",
  funcCartThemeColorUpsertFailed: "कार्ट रङ अपसर्ट गर्न असफल भयो",
  funcOpsiteCreateFailed: "साइट सामग्री सिर्जना गर्न असफल भयो",
  alphabetValid: "कम्तिमा एउटा ठूलो अक्षर र सानो अक्षर हुनुपर्दछ",
  numberValid: "कम से कम एक नंबर होना चाहिए",
  symbolValid: "कम से कम एक प्रतीक होना चाहिए",
  credentialNotSet: "क्रेडेन्शियल सेट गरिएको छैन",
  validBankAccFormat: "अमान्य बैंक एसीसी नं. ढाँचा",
  moreThan: "{नाम} {नाम २} भन्दा कम वा बराबर हुनुपर्दछ",
  lessThan: "{नाम} {नाम २} भन्दा बढी वा बराबर हुनुपर्दछ।",
  bankAccountNotAvailable: "बैंक खाता उपलब्ध छैन।",
  insufficientCredit: "अपर्याप्त क्रेडिट",
  enableRequired: "सक्षम पार्नु आवश्यक छ।",
  funcAddGameFailed: "खेल थप्न असफल भयो।",
  funcAddGameRewardByBatchFailed: "ब्याच द्वारा खेल इनाम थप्न असफल भयो।",
  funcAddGameRewardFailed: "खेल इनाम थप्न असफल भयो।",
  funcAddGameTemplateFailed: "खेल टेम्प्लेट थप्न असफल भयो।",
  funcAddLayoutTemplateFailed: "लेआउट टेम्प्लेट थप्न असफल भयो।",
  funcAddOperatorGameFailed: "अपरेटर खेल थप्न असफल भयो",
  funcAddOperatorMemberWalletFailed: "अपरेटर सदस्य वालेट थप्न असफल भयो",
  funcDeleteGameFailed: "खेल मेट्न असफल भयो",
  funcDeleteGameRewardFailed: "खेल इनाम मेट्न असफल भयो",
  funcDeleteGameTemplateFailed: "खेल टेम्प्लेट मेट्न असफल भयो।",
  funcDeleteLayoutTemplateFailed: "लेआउट टेम्प्लेट मेट्न असफल भयो",
  funcDeleteOperatorGameFailed: "अपरेटर खेल मेट्न असफल भयो",
  funcUpdateGameFailed: "खेल अद्यावधिक गर्न असफल भयो",
  funcUpdateGameRewardFailed: "खेल इनाम अद्यावधिक गर्न असफल भयो।",
  funcUpdateGameTemplateFailed: "खेल टेम्प्लेट अद्यावधिक गर्न असफल भयो।",
  funcUpdateLayoutTemplateFailed: "लेआउट टेम्प्लेट अद्यावधिक गर्न असफल भयो।",
  funcUpdateOperatorGameFailed: "अपरेटर खेल अद्यावधिक गर्न असफल भयो।",
  gameCannotBeRemove: "खेल हटाउन सकिदैन।",
  gameNameCannotBeUse: "खेल नाम प्रयोग गर्न सकिदैन।",
  gameNameMaxLength150: "खेलको नाम बढीमा १५० क्यारेक्टर हुनुपर्दछ।",
  gameRewardCannotBeUse: "खेल इनाम प्रयोग गर्न सकिँदैन।",
  gameRewardLimitExceeded: "खेल इनाम सीमा पार",
  gameTemplateExist: "खेल टेम्प्लेट पहिल्यै अवस्थित छ।",
  gameTypeMaxLength20: "खेल प्रकार बढीमा २० क्यारेक्टर हुनुपर्दछ।",
  invalidGame: "अवैध खेल",
  invalidGameReward: "अवैध खेल इनाम",
  invalidGameTemplate: "अवैध खेल टेम्प्लेट",
  invalidMemberWallet: "अवैध सदस्य वालेट",
  invalidOperatorGame: "अवैध अपरेटर खेल",
  invalidRewardProbability: "अवैध इनाम संभावना",
  invalidTemplate: "अवैध टेम्प्लेट",
  maxGameRewardRequired: "अधिकतम खेल इनाम आवश्यक छ।",
  maxMiniGameRewardRequired: "अधिकतम मिनी-गेम इनाम आवश्यक छ।",
  memberWalletAlrdExist: "सदस्य वालेट पहिल्यै अवस्थित छ।",
  operatorGameCannotBeUse: "अपरेटर खेल प्रयोग गर्न सकिदैन।",
  operatorGameIdRequired: "अपरेटर गेम आईडी आवश्यक छ",
  rewardCodeMaxLength20: "इनाम कोड अधिकतम 20 क्यारेक्टरहरू हुनुपर्दछ।",
  rewardCodeRequired: "इनाम कोड आवश्यक छ।",
  rewardCurrencyMaxLength5: "इनाम मुद्रा बढीमा 5 क्यारेक्टर हुनुपर्दछ।",
  rewardCurrencyRequired: "इनाम मुद्रा आवश्यक छ।",
  rewardDescriptionMaxLength100: "इनाम विवरण बढीमा 100 क्यारेक्टरहरू हुनुपर्दछ।",
  rewardNameMaxLength50: "इनाम नाम बढीमा 50 क्यारेक्टरहरू हुनुपर्दछ।",
  rewardProbabilityRequired: "इनाम संभावना आवश्यक छ।",
  rewardRequired: "इनाम आवश्यक छ।",
  selectedTemplateMaxLength30: "चयन गरिएको टेम्प्लेट बढीमा ३० क्यारेक्टर हुनुपर्दछ।",
  selectedTemplateRequired: "चयन गरिएको टेम्प्लेट आवश्यक छ।",
  success: "सफलता",
  templateCannotBeRemove: "टेम्प्लेट हटाउन सकिदैन।",
  templateCodeCannotBeUse: "टेम्प्लेट कोड प्रयोग गर्न सकिदैन।",
  templateCodeMaxLength30: "टेम्प्लेट कोड बढीमा ३० क्यारेक्टर हुनुपर्दछ।",
  templateCodeRequired: "टेम्प्लेट कोड आवश्यक छ।",
  templateNameMaxLength50: "टेम्प्लेट नाम बढीमा ५० क्यारेक्टर हुनुपर्दछ।",
  tokenRequestRequired: "टोकन अनुरोध आवश्यक छ।",
  tokenRequired: "टोकन आवश्यक छ",
  mustMoreThan: "{फनाम} {एफभ्यालु} भन्दा बढी हुनुपर्दछ",
  mustMoreThanOrEqual: "{फनाम} {एफभ्यालु} भन्दा बढी वा बराबर हुनुपर्दछ",
  tokenInvalid: "{कुञ्जी}मा टोकन आगत अवैध",
  cashInvalid: "{कुञ्जी}मा नगद आगत अवैध",
  atLeastOneRequired: "कम से कम एक आवश्यक है",
  cash1To7Required: "नगद १ देखि ७ सम्म चाहिन्छ",
  cash1To6Required: "नगद १ देखि ६ सम्म चाहिन्छ",
  cash1To5Required: "नगद १ देखि ५ सम्म चाहिन्छ",
  cash1To4Required: "नगद १ देखि ४ आवश्यक छ",
  cash1To3Required: "नगद १ देखि ३ आवश्यक छ",
  cash1To2Required: "नगद १ देखि २ आवश्यक छ",
  cash1Required: "नगद १ आवश्यक छ",
  token1To7Required: "टोकन १ देखि ७ आवश्यक छ",
  token1To6Required: "टोकन १ देखि ६ आवश्यक छ",
  token1To5Required: "टोकन १ देखि ५ आवश्यक छ",
  token1To4Required: "टोकन १ देखि ४ आवश्यक छ",
  token1To3Required: "टोकन १ देखि ३ आवश्यक छ",
  token1To2Required: "टोकन १ देखि २ आवश्यक छ",
  token1Required: "टोकन १ आवश्यक छ",
  cycleRequired: "चक्र आवश्यक छ",
  targetAmountRequired: "लक्षित रकम आवश्यक छ",
  gamifyIdRequired: "रिवार्ड आईडी आवश्यक छ",
  gamifyMemberProcessed: "इनाम सदस्य संसाधित",
  gamifyNotExists: "इनाम अस्तित्वमा छैन",
  gamifyInactive: "इनाम निष्क्रिय",
  invalidCycle: "अवैध चक्र",
  memberIdMaxLength50: "सदस्य आईडी ५० क्यारेक्टरभन्दा बढी हुनुहुँदैन",
  funcAddGameWalletFreeCreditFailed: "गेम वालेटमा नि: शुल्क क्रेडिट थप्न असफल भयो",
  funcUpdateOperatorMemberWalletBalanceFailed: "अपरेटर सदस्य वालेट ब्यालेन्स अद्यावधिक गर्न असफल भयो",
  funcUpdateOperatorMemberWalletBalanceByFrozenFailed: "जमेको रकमद्वारा अपरेटर सदस्य वालेट ब्यालेन्स अद्यावधिक गर्न असफल भयो",
  mustHaveBothAlphaNumOnly: "वर्णमाला र संख्याहरू मात्र प्रयोग गर्नुहोस्, प्रत्येकको कम्तिमा एकको साथ।",
  setupGameRewardBeforeEnable: "कृपया यसलाई सक्षम पार्नु अघि खेल इनाम सेट अप गर्नुहोस्।",
  rewardProbabilityMustNotAllZero: "इनाम संभावनाहरू सबै शून्य हुनुहुँदैन।",
  totalRewardProbabilityCannotOver100: "कुल इनाम संभावना 100 से अधिक नहीं हो सकती",
  credential1To2Required: "क्रेडेन्शियल १ देखि २ आवश्यक छ।",
  credential1To4Required: "क्रेडेन्शियल १ देखि ४ आवश्यक छ।",
  newRemarkRequired: "टिप्पणी आवश्यक छ।",
  notSupportedWithdrawalPG: "समर्थन नभएको निकासी भुक्तानी गेटवे।",
  prizeInvalid: "{key} मा पुरस्कार इनपुट अवैध छ",
  exceedMaxCampaignCount: "अधिकतम लिडरबोर्ड अभियान नाघिएको छ।",
  leaderboardCampaignEnded: "लिडरबोर्ड अभियान समाप्त भयो।",
  leaderboardCampaignStarted: "लिडरबोर्ड अभियान सुरु भयो।",
  leaderboardCampaignSettled: "लिडरबोर्ड अभियान सम्पन्न भयो।",
  pleaseSelectUpToNoPhone: "कृपया अधिकतम {fname} फोन नम्बर चयन गर्नुहोस्।",
  phoneNotAvailable: "फोन उपलब्ध छैन।",
  batchExpired: "ब्याच सकियो।",
  remarkNotSame: "टिप्पणी मिल्दैन",
  partnerIdRequired: "साझेदार ID आवश्यक छ",
  partnerNotExists: "साझेदार अवस्थित छैन",
  urgencyRequired: "आपतकालीन अवस्था आवश्यक छ",
  groupSizeRequired: "समूहको आकार आवश्यक छ",
  inactiveDaysRequired: "निष्क्रिय दिन आवश्यक छ",
  idRequired: "ID आवश्यक छ",
  expiryRequired: "म्याद सकिने मिति आवश्यक छ",
  batchIdRequired: "ब्याच ID आवश्यक छ",
  requestDateRequired: "अनुरोध मिति आवश्यक छ",
  requestByRequired: "अनुरोधकर्ता आवश्यक छ",
  cpiIdRequired: "CPI ID आवश्यक छ",
  assigneeRequired: "जिम्मेवार आवश्यक छ",
  phoneNotAvailable: "फोन उपलब्ध छैन",
  liveChatNotExists: "प्रत्यक्ष च्याट अवस्थित छैन",
  resultNotExists: "नतिजा अवस्थित छैन",
  lastLaunchFundTransfer: "पछिल्लो प्रारम्भ कोष स्थानान्तरण",
  alreadyRegistered: "पहिले नै दर्ता गरिएको छ",
  invalidId: "अवैध ID",
  batchExpired: "ब्याच म्याद सकियो",
  teleCalling: "टेलिफोन कल",
  invalidUrgency: "अवैध आपतकालीन अवस्था",
  appTypeRequired: "एप्लिकेशन प्रकार आवश्यक छ",
  invalidAppType: "अवैध एप्लिकेशन प्रकार",
  appLinkRequired: "एप्लिकेशन लिंक आवश्यक छ",
  invalidDomain: "अवैध डोमेन",
  existEndDateGtEndDate: "विद्यमान अन्त्य मिति नयाँ अन्त्य मितिभन्दा ढिलो छ",
  newRemark2Required: "नयाँ टिप्पणी 2 आवश्यक छ",
  remark2NotSame: "टिप्पणी 2 मिल्दैन",
  remark2Required: "टिप्पणी 2 आवश्यक छ",
  nameRequired: "नाम आवश्यक छ",
  aiAssistantNotExists: "AI सहायक अवस्थित छैन",
  aiAssistantInactive: "AI सहायक निष्क्रिय छ",
  phoneStartWithVND: "फोन नम्बर 84 बाट सुरु हुनुपर्छ",
  otherActiveLiveChat: "अर्को सक्रिय LiveChat छ",
  whiteLabelRequired: "White Label आवश्यक छ",
  invalidWhiteLabel: "अवैध White Label",
  baseRateDepositRequired: "आधार दर जम्मा आवश्यक छ",
  revisionRequired: "संशोधन आवश्यक छ",
  typeDescRequired: "प्रकार विवरण आवश्यक छ",
  riskWeightRequired: "जोखिम वजन आवश्यक छ",
  linkageTypeRequired: "लिङ्केज प्रकार आवश्यक छ",
  valueRequired: "मान आवश्यक छ",
  baseRateWithdrawalRequired: "आधार दर निकासी आवश्यक छ",
  sourceIdRequired: "स्रोत आईडी आवश्यक छ",
  targetIdRequired: "लक्ष्य आईडी आवश्यक छ",
  linkageTypeNotExists: "लिङ्केज प्रकार अवस्थित छैन",
  phoneStartWithMYR: "फोन नम्बर 60 बाट सुरु हुनुपर्छ",
  minWithdrawalAmount100: "न्यूनतम निकासी रकम 100 हो",
  invalidReward: "अवैध रिवार्ड",
  noRow: "कुनै पङ्क्ति छैन",
  credentialRequired: "क्रेडेन्सियल आवश्यक छ",
  settlementIdRequired: "सेटलमेन्ट ID आवश्यक छ",
  settlementDateRequired: "सेटलमेन्ट मिति आवश्यक छ",
  newCryptoAddressRequired: "नयाँ क्रिप्टो ठेगाना आवश्यक छ",
  cryptoAddressRequired: "क्रिप्टो ठेगाना आवश्यक छ",
  settlementTypeRequired: "सेटलमेन्ट प्रकार आवश्यक छ",
  chatProviderRequired: "च्याट प्रदायक आवश्यक छ",
  countRequired: "संख्या आवश्यक छ",
  voucherCodeRequired: "भाउचर कोड आवश्यक छ",
  eventTypeRequired: "इभेन्ट प्रकार आवश्यक छ",
  viewTypeRequired: "दृश्य प्रकार आवश्यक छ",
  actionTypeRequired: "कार्य प्रकार आवश्यक छ",
  thresholdRequired: "थ्रेसहोल्ड आवश्यक छ",
  missionIdRequired: "मिशन ID आवश्यक छ",
  ruleIdRequired: "रूल ID आवश्यक छ",
  aggregatorRequired: "एग्रिगेटर आवश्यक छ",
  rebateIdRequired: "रिबेट ID आवश्यक छ",
  liveChatExists: "यो लाइभच्याट पहिले नै अवस्थित छ",
  triggerNotExists: "ट्रिगर अवस्थित छैन",
  missionRuleNotExists: "मिशन रूल अवस्थित छैन",
  invalidVoucherCode: "अमान्य भाउचर कोड",
  invalidRebateType: "अमान्य रिबेट प्रकार",
  invalidSettlementType: "अमान्य सेटलमेन्ट प्रकार",
  missionNotExists: "मिशन अवस्थित छैन",
  settlementTypeNotExists: "सेटलमेन्ट प्रकार अवस्थित छैन",
  parentTriggerInactive: "प्यारेन्ट ट्रिगर निष्क्रिय",
  parentMissionInactive: "प्यारेन्ट मिशन निष्क्रिय",
  missionRuleNotSet: "मिशन रूल सेट गरिएको छैन",
  invalidCreditType: "अमान्य क्रेडिट प्रकार",
  cryptoDisabled: "क्रिप्टो असक्षम गरिएको छ",
  depositExists: "डिपोजिट पहिले नै अवस्थित छ",
  parentSettlementTypeNotExists: "प्यारेन्ट सेटलमेन्ट प्रकार अवस्थित छैन",
  accessControlNotExists: "एक्सेस कन्ट्रोल अवस्थित छैन",
  cryptoAccountFull: "क्रिप्टो खाता भरिएको छ",
  cryptoAccountExists: "क्रिप्टो खाता पहिले नै अवस्थित छ",
  cryptoAccountNotExists: "क्रिप्टो खाता अवस्थित छैन",
  settlementNotAvailable: "सेटलमेन्ट उपलब्ध छैन",
  settlementProcessed: "सेटलमेन्ट प्रक्रिया गरिएको छ",
  cryptoAccountInactive: "क्रिप्टो खाता निष्क्रिय",
  leadIdRequired: "लीड ID आवश्यक छ",
  failedToCreateFreeRound: "फ्री राउन्ड सिर्जना गर्न असफल भयो।",
  failedToGetFreeRound: "फ्री राउन्ड प्राप्त गर्न असफल भयो।",
  failedToGetFreeRoundGameList: "फ्री राउन्ड खेल सूची प्राप्त गर्न असफल भयो।",
  tierFull: "स्तर भरिएको",
  tierNotExists: "स्तर अवस्थित छैन",
  ticketTypeRequired: "टिकट प्रकार आवश्यक छ",
  invalidTicketType: "अवैध टिकट प्रकार",
  positionRequired: "स्थिति आवश्यक छ",
  invalidPosition: "अवैध स्थिति",
  invalidBonusRate: "अवैध बोनस दर",
  minRequired: "न्यूनतम मान आवश्यक छ",
  maxRequired: "अधिकतम मान आवश्यक छ",
  minGtMax: "न्यूनतम मान अधिकतमभन्दा ठूलो छ।",
  sessionExists: "सेसन पहिले नै अवस्थित छ",
  sessionOverlaps: "सेसन एकअर्कासँग ओभरल्याप भएको छ",
  sessionIdRequired: "सेसन ID आवश्यक छ",
  sessionNotExists: "सेसन अवस्थित छैन",
  nameExists: "नाम पहिले नै अवस्थित छ",
  sessionElapsed: "सेसन समाप्त भएको छ",
  validUrl: "कृपया मान्य URL प्रविष्ट गर्नुहोस्",
  minBalanceNotMet: "न्यूनतम ब्यालेन्स पूरा भएको छैन",
  validSlugFormat: "अमान्य स्लग ढाँचा",

  failedToCancelFreeRound: "फ्री राउन्ड रद्द गर्न असफल भयो।",
  failedToGetFreeRoundLineBet: "फ्री राउन्डको लाइन बेट प्राप्त गर्न असफल भयो।",
};